import { Injectable } from '@angular/core';
import { TestataIntervento, InterventiFilterData } from 'src/app/common/models/Intervento';
import { DateUtility } from 'src/app/common/utilities/DateUtils';
import { SqlAdapterService, SqlStatement } from 'src/app/common/sharedServices/sql/sql-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class InterventiSqlAdapterService {
  readonly SCHEMA = `(
    aziCdazi VARCHAR(3) NOT NULL,
    idIntervento INTEGER NOT NULL,
    codiceStatoIntervento VARCHAR(2) NOT NULL,
    codiceCommessa VARCHAR(30) NOT NULL,
    ragioneSociale VARCHAR(200) NOT NULL,
    dataInterventoStr VARCHAR(10) NOT NULL,
    oggetto TEXT NOT NULL,
    CONSTRAINT pk_interventi PRIMARY KEY (aziCdazi, idIntervento)
  );`;

  constructor(private sql: SqlAdapterService) {
    this.initTable();
  }

  private async initTable() {
    const query = `CREATE TABLE IF NOT EXISTS Interventi ${this.SCHEMA}`;
    try {
      const created = await this.sql.execute({
        statement: query,
      });
      console.log('Created table Interventi ? ', created);
    } catch (error) {
      console.error('Errore while creating table Interventi', error);
    }
  }

  async inserisciInterventi(interventi: TestataIntervento[]) {
    const insertQueries = interventi.map(this.getSingleInsertQuery);
    try {
      const inserted = await this.sql.executeSet(insertQueries);
      console.log('Inserted into table Interventi ? ', inserted);
    } catch (error) {
      console.error('Errore while inserting data into table Interventi', error);
    }
  }

  /**
   * Rimuove tutti gli interventi presenti a DB
   */
  async rimuoviInterventi() {
    const query = `DELETE FROM Interventi ;`;
    try {
      const removed = await this.sql.execute({
        statement: query
      });
      console.log('Removed all Interventi ? ', removed);
    } catch (error) {
      console.error('Errore while removing from table Interventi', error);
    }
  }

  /**
   * Prova ad aggiornare l'intervento fornito salvato eventualmente sul DB per
   * mantenere i dati consistenti
   * Può fallire
   * @param intervento 
   */
  async updateIntervento(intervento: TestataIntervento) {
    const query = `UPDATE Interventi SET oggetto = ? WHERE (idIntervento = ? AND aziCdazi = ?) ;`;
    try {
      const updated = await this.sql.execute({
        statement: query,
        values: [JSON.stringify(intervento), intervento.idIntervento, intervento.aziCdazi]
      });
      console.log('Update existing intervento  ? ', updated);
    } catch (error) {
      console.error('Errore while updating data from table Interventi', error);
    }
  }

  private getSingleInsertQuery(intervento: TestataIntervento): SqlStatement {
    const dataIntervento = DateUtility.generateIsoShortDateString(new Date(intervento.dataIntervento));
    return {
      statement: `INSERT INTO Interventi (aziCdazi, idIntervento, codiceStatoIntervento, codiceCommessa, ragioneSociale, dataInterventoStr, oggetto) 
      VALUES (?, ?, ?, ?, ?, ?, ?)`,
      values: [
        intervento.aziCdazi, intervento.idIntervento, intervento.codiceStatoIntervento,
        intervento.codiceCommessa, intervento.ragioneSociale, dataIntervento, JSON.stringify(intervento)]
    };
  }

  async fetchTestateInterventiOffline(
    aziCdazi: string,
    filtri: InterventiFilterData,
    numeroPagina: number,
    ordineDescrescente: boolean
  ): Promise<TestataIntervento[]> {
    const statiAbilitatiList = filtri.filtroStatoIntervento.split(',').map(numberStr => `'${numberStr}'`).join(',');

    const selectField = `SELECT aziCdazi, codiceStatoIntervento, codiceCommessa, ragioneSociale, dataInterventoStr, oggetto FROM Interventi`;
    let whereClause = `aziCdazi = '${aziCdazi}' AND codiceStatoIntervento IN (${statiAbilitatiList}) AND UPPER (ragioneSociale) LIKE '%${filtri.filtroRagioneSociale.toUpperCase()}%' AND UPPER(codiceCommessa) LIKE '%${filtri.filtroCodiceCommessa.toUpperCase()}%' `;
    if (filtri.filtroDaDataInterventoIsoString) {
      whereClause += this.getQueryDateFromField(filtri.filtroDaDataInterventoIsoString);
    }
    if (filtri.filtroADataInterventoIsoString) {
      whereClause += this.getQueryDateToField(filtri.filtroADataInterventoIsoString);
    }
    const query = `${selectField} WHERE (${whereClause}) ORDER BY dataInterventoStr ${ordineDescrescente ? 'DESC' : 'ASC'} LIMIT ${(numeroPagina - 1) * 1000}, 1000; `;
    console.debug('DEbug search query', query);
    try {
      const records = await this.sql.execute({
        statement: query,
        values: []
      });

      const result = [];
      for (let k = 0; k < records.values.length; k++) {
        result.push(records.values[k]);
      }
      console.debug('Select interventi result', result);
      return result.map(row => JSON.parse(row.oggetto));
    } catch (error) {
      console.error('Errore while selecting data from table Interventi', error);
      return [];
    }
  }

  private getQueryDateFromField(filterDateISO: string): string {
    const date = new Date(filterDateISO);
    return `AND dataInterventoStr >= '${DateUtility.generateIsoShortDateString(date)}' `;
  }

  private getQueryDateToField(filterDateISO: string): string {
    const date = new Date(filterDateISO);
    return `AND dataInterventoStr <= '${DateUtility.generateIsoShortDateString(date)}' `;
  }

  private async debugTable() {
    const query = `PRAGMA table_info(Interventi);`;
    const result = await this.sql.execute({
      statement: query,
    });
    console.log(result);

    const select = `SELECT * FROM Interventi LIMIT 20 ;`;
    const result2 = await this.sql.execute({
      statement: select,
    });
    console.log(`Contenuto della tabella Interventi ?`, result2);

  }

}
